export const ArenaTicketTypeList = [
    { label: 'Standard', value: 1 },
    { label: 'Premium', value: 2 }
];
